export const SibSymbols = {
    SibContext: Symbol.for("SibContext"),
    SibProvider: Symbol.for("SibProvider")
}